var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "250px",
    height: "209.388px",
    viewBox: "0 0 250 209.388",
    enableBackground: "new 0 0 250 209.388",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M152.5,34.744c-3.8,5.4-6.8,6-17.4,6c-3.8,7-10,20-19.399,39.199c-1.6,3.2-2.8,6.2-4.4,8.6l-0.2,0.8 c-5.4,10.2-31.8,96.598-57.799,107.199c-17,6.999-36-0.801-40.799-5.601c-8-8.399-9.6-26.6-3-29.999 c2.2-1.2,11.2,16.399,19.4,16.999c14.8,1.601,26.799-7.999,31-15.999c10.2-19.4,21-51,31-73.799 c11.8-25.799,15-35.399,20.8-47.199c-6.2-0.6-14.4-1.8-33.6,0.8c-10.4,2.6-17.4-9.8,7.2-14.6c10.6-2.2,22.4-4.4,32-5 c0.6-0.2,1.4-0.2,2.4-0.2v-0.2l3-5.6c3.2-4.2,6.6-2,8.8-1.4c2.2,0.2,4,2.6,5.4,5.8c5.4-0.6,8-0.6,11-1.2 C152.3,18.744,155.699,29.544,152.5,34.744z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.299,131.142c-6,8.6-40,36.6-83.999,40.399c-9.8,1-17.2,0.8-22.2,0c-1.6,3.8-3.4,7-5,10c-3.4,4.8-6.4,8-8.6,7.8 c-5.4-0.4-9.399-12.6-6.8-26.6c0.8-6.2,49-100.398,57.799-116.398c9-15.8,16.4-32.6,17.4-35.599c1.4-3,3.6-5.2,11.399-1 c3,1.8,5.6,6.2,4.2,8.4c-0.6,0.6-3.6,6.6-8.2,15.6c32.999-28.2,59.799-19.6,65.199-1c4.8,16.2-12.8,43-57.399,65.199 c11.2-2.6,19.2-4.2,22.2-3.6C228.899,98.143,226.299,115.943,216.299,131.142z M197.699,107.343c-5.8-5.2-39.799,0.8-67.199,13.2 v0.2c-3.8,5.8-14.2,34.399-18.399,45.599C169.1,166.342,206.699,115.543,197.699,107.343z M134.301,111.343l0.2-0.6 c22.6-13,89.999-49.199,80.399-71.599c-8.6-18.6-46.199,10.6-55.399,19C150.7,75.743,140.9,95.543,134.301,111.343z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.868fd4e5ff575e07d17fb248063c6244.svg";
export { ForwardRef as ReactComponent };